export const storyCardClicked = ({ quote, attribution, action }) => ({
  type: 'Story Card Clicked',
  data: {
    quote,
    attribution,
    action,
  },
});

export const storyCardModalOpened = ({ quote, attribution, mediaType }) => ({
  type: 'Story Card Modal Opened',
  data: {
    quote,
    attribution,
    media_type: mediaType,
  },
});
